import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { GroupSignature } from '@design-system/group-signature';
import { useI18n } from '@design-system/i18n';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
export const GroupAndContentType = ({ group, type, }) => {
    const { __ } = useI18n();
    return (_jsx(Box, { mb: 2, children: _jsxs(Box, { children: [group && (_jsxs(_Fragment, { children: [_jsx(ScreenReadersContent, { children: __(`Belongs to:`) }), _jsx(GroupSignature, { groupName: group.name, logoSrc: group.logoSrc })] })), _jsxs(Box, { alignItems: "center", children: [group && type && _jsx(SpanWrapper, { children: "\u00B7" }), type && (_jsxs(Box, { color: "primary", font: "metadata-semibold-asphalt", children: [_jsx(ScreenReadersContent, { children: __(`Type of content:`) }), _jsx("span", { children: type })] }))] })] }) }));
};
const SpanWrapper = styled.span `
  margin: 0 ${({ theme }) => theme.space[1]}px;
`;
//# sourceMappingURL=GroupAndContentType.js.map